import { normalizedFactors, reducedDimensions } from './reducedDimensions.js';
export default function resolveReduction(source, reduction) {
    const factors = normalizedFactors(reduction.factors);
    const sourceOffset = (reduction.sourceOffset ?? [0, 0, 0]);
    const sourceDimensions = (reduction.sourceDimensions ??
        source.dimensions);
    return {
        factors,
        sourceOffset,
        sourceEnd: [
            sourceOffset[0] + sourceDimensions[0],
            sourceOffset[1] + sourceDimensions[1],
            sourceOffset[2] + sourceDimensions[2],
        ],
        dimensions: reducedDimensions(sourceDimensions, factors),
    };
}
